import React, { useState, useEffect } from 'react';
import { useStateSelector } from '../../../../store/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import PortalTooltip from '../../../../components/PortalTooltip/PortalTooltip';
import '../../../../components/DocumentListCard/DocumentListCard.scss';
import '../../../../components/DocumentTile/DocumentTile.scss';
import './ConnectMarketplaceTemplates.scss';

interface SampleTemplate {
    id: number;
    name: string;
    fileName: string;
    uploadedAt: string;
}

const ConnectMarketplaceTemplates = () => {
    const axios = useStateSelector((state) => state.core.axios);
    const [templates, setTemplates] = useState<SampleTemplate[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadingId, setDownloadingId] = useState<number | null>(null);

    const getTemplates = () => {
        setIsLoading(true);
        setTemplates([]);

        axios
            .get('/api/Marketplace/MarketplaceSampleTemplates', {
                params: {
                    pageNumber: 1,
                    pageSize: 100,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    const templateList: SampleTemplate[] = response.data.list || response.data.items || [];
                    setTemplates(templateList);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDownload = (templateId: number) => {
        setDownloadingId(templateId);
        axios
            .get(`/api/Marketplace/MarketplaceSampleTemplates/${templateId}`)
            .then((response) => {
                if (response.status === 200) {
                    const downloadUrl = response.data.url || response.data;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setDownloadingId(null);
            });
    };

    const getTooltipId = (templateId: number) => {
        return `template-tooltip-${templateId}`;
    };

    useEffect(() => {
        getTemplates();
    }, []);

    return (
        <div className="connect-marketplace-templates">
            <div className="documents-container">
                {isLoading ? (
                    <div className="loading-message">Loading...</div>
                ) : templates.length > 0 ? (
                    templates.map((template) => (
                        <div
                            key={`document-${template.id}-${template.name}`}
                            style={{ width: 142, height: 60 }}
                            className={`document-tile ${downloadingId === template.id ? 'downloading' : ''}`}
                            onClick={() => handleDownload(template.id)}>
                            <div className="icon-container">
                                <FontAwesomeIcon
                                    inverse
                                    className="icon"
                                    icon={faFileAlt as any}
                                />
                            </div>
                            <div className="file-info">
                                <div 
                                    className="file-name"
                                    id={getTooltipId(template.id)}>
                                    {template.name}
                                </div>
                                <PortalTooltip
                                    anchorId={getTooltipId(template.id)}
                                    delayShow={300}
                                    place="top"
                                    content={template.name}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-templates-message">
                        No templates available
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConnectMarketplaceTemplates;
